import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { error } from 'console';
import { Validators } from 'ngx-editor';
import { map, filter, tap, BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { VitalHttpServices } from 'src/app/core/services/VitalHttpServices';
import { DialogService } from 'src/app/core/services/dialog.service';
import { LabadminService } from 'src/app/labadmin/labadmin.service';

@Component({
  selector: 'app-fax',
  templateUrl: './fax.component.html',
  styleUrls: ['./fax.component.scss']
})
export class FaxComponent implements OnInit {

  constructor(
    private _labadminservice: LabadminService,
    private _vitalHttpServices: VitalHttpServices,
    private _fb: FormBuilder,
    private _dailogService: DialogService,
    public _dialogRef: MatDialogRef<FaxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick() {
    this._dialogRef.close('');
  }

  faxAdvanceAlert = '';
  casetypesList: any = []
  accountId: number = this.data.accountId
  ruleName: string = this.data.ruleName
  physicianList: any=[]
  ruleId: number = 0
  loggedInUserId = this.data.loggedInUserId
  labOrgId: number = this.data.labOrgid
  orderingCaseCategorySelection = new SelectionModel<any>(true, []);
  orderingPhysicianSelection = new SelectionModel<any>(true, []);
  orderingServiceSelection = new SelectionModel<any>(true, []);
  labAccountDetails = this.data.labAccountDetails
  caseCategoriesList: any = []
  SavedVAExclusionData: VaRulesExclusions[] = []
  defaultServices: any
  saveFilteredCaseTypes: any = [];

  faxForm = this._fb.group({
    laboratory: [0, [Validators.required]]
  })

  get getter() {
    return this.faxForm.controls.laboratory
  }

  ngOnInit(): void {

    this.faxForm.controls.laboratory.valueChanges.subscribe((res) => {
      this.LoadCaseCategoryPhysicianDataForFax(res)
    })
    if (this.labAccountDetails.length == 1) {
      this.faxForm.controls.laboratory.patchValue(this.labAccountDetails[0].AccountId)
    }
  }

  LoadCaseCategoryPhysicianDataForFax(locationId: any = '') {
    var LabaccountId = locationId == '' ? 0 : locationId
    const searchValue = `${locationId}_${this.accountId}_${this.ruleName}`
    this.GetVARulesSearchDetails(searchValue, LabaccountId)
  }

  GetVARulesSearchDetails(SearchValue: string, labaccountid: any) {
    this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(true))
    this._labadminservice.GetVARulesSearchDetails(SearchValue, this._labadminservice.deploymentKey)
      .subscribe({
        next: (data: any[]) => {
          this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(false))
          if (data.length) {
            this.ruleId = data[0].RuleId
            if (this.ruleId) {
              this.VaruleExclusionDetails(this.ruleId, labaccountid)
            }
            else this.getFaxAndPrintingData(labaccountid)
          }
          else this.getFaxAndPrintingData(labaccountid)
        }, error: (err) => {
          console.error(err)
          this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(false))
        }
      })
  }

  getCasetypeByAccId(labAccId): Observable<any> {

    const exclusionIds = new Set(
      this.SavedVAExclusionData
        .filter(exclusion => exclusion.entityType === 'Casetype')
        .map(exclusion => exclusion.entityId)
    );
    return this._labadminservice.getCaseCategoryByAccId('0', this.labOrgId, labAccId, this._labadminservice.deploymentKey).pipe(
      map(caseCategories =>
        caseCategories.map(category => ({
          ...category,
          selectionModel: new SelectionModel(true, [...this.getCasetypeIdHelper(category.Cases.filter(caseItem => !exclusionIds.has(caseItem.CaseType)))])
        }))
      )
    )
  }

  getCasetypeDisplayNameHelper(caseType: any) {
    return caseType.reduce((p, c) => ([...p, c.CaseTypeDisplayname]), [])
  }

  getCasetypeIdHelper(caseType: any) {
    return caseType.reduce((p, c) => ([...p, c.CaseTypeId]), [])
  }

  saveCaseType() {
    var res = this.caseCategoriesList.reduce((p, c) => (p || c.selectionModel.hasValue()), false)

    if (!res && this.orderingServiceSelection.selected.length == 0 && this.orderingPhysicianSelection.selected.length == 0) {
      this._dailogService.openDialog('Alert', 'Excluding all is not allowed, Please include at least one checkbox in each Category', '', 'OK', 'dontshow')
      return
    }


    for (const obj of this.caseCategoriesList) {

      let selectedCaseIds = obj.selectionModel.selected
      obj.Cases.map((i: any) => {
        if (!selectedCaseIds.includes(i.CaseTypeId)) {
          this.saveFilteredCaseTypes.push({
            "ruleId": this.ruleId,//to be added
            "entityType": 'Casetype',
            "entityId": i.CaseType,
            "Type": this.ruleName,
            "Labid": this.faxForm.controls.laboratory.value
          })
        }
      });
    }

    this.defaultServices.filter((x: any) => !this.orderingServiceSelection.selected.includes(x)).map((i: any) => {
      this.saveFilteredCaseTypes.push({
        "ruleId": this.ruleId,
        "entityType": 'Service',
        "entityId": i.value,
        "Type": this.ruleName,
        "Labid": this.faxForm.controls.laboratory.value
      })
    });

    this.physicianList.filter((x: any) => !this.orderingPhysicianSelection.selected.includes(x)).map((i: any) => {
      this.saveFilteredCaseTypes.push({
        "ruleId": this.ruleId,
        "entityType": 'orderingPhysician',
        "entityId": i.UserID,
        "Type": this.ruleName,
        "Labid": this.faxForm.controls.laboratory.value
      })
    });

    if (this.ruleId > 0) {
      this.DeleteVaRulesExclusions(this.ruleId, this.saveFilteredCaseTypes)
      this._dialogRef.close('')
    }
    else this._dialogRef.close(this.saveFilteredCaseTypes);
  }

  DeleteVaRulesExclusions(ruleID: number, resData: any) {
    
    this._labadminservice.DeleteVaRulesExclusions(ruleID, this._labadminservice.deploymentKey).subscribe({
      next: (data) => {
        this._labadminservice.InsertVARulesExclusions(this.loggedInUserId, resData, this._labadminservice.deploymentKey).subscribe({
          error: (err) => console.error(err)
        })
      },
      error: (err) => console.error(err)
    })
  }

  toggleAllCaseCategory(caseCategoriesList) {
    if (this.isAllCasesCategorySelected(caseCategoriesList)) {
      for (let i of caseCategoriesList) {
        i.selectionModel.clear()
      }
      return
    }
    for (let i of caseCategoriesList) {
      i.selectionModel.clear();
      i.selectionModel.select(...this.getCasetypeIdHelper(i.Cases))
    }
  }

  isAllCasesCategorySelected(caseCategoriesList) {
    return caseCategoriesList.reduce((p, c) => (p && this.isAllCaseSelected(c.Cases, c.selectionModel)), true)
  }

  toggleAllCases(caseCategoryList, selectionmodel) {
    if (this.isAllCaseSelected(caseCategoryList.Cases, selectionmodel)) {
      selectionmodel.clear()
      return
    }
    selectionmodel.select(...this.getCasetypeIdHelper(caseCategoryList.Cases))
  }

  isAllCaseSelected(casesList, selectionmodel) {
    return casesList.length === selectionmodel.selected.length
  }

  toggleAllServices() {
    if (this.isSelectedService()) {
      this.orderingServiceSelection.clear();
      return;
    }
    this.orderingServiceSelection.select(...this.defaultServices);
  }

  isSelectedService() {
    const numSelected = this.orderingServiceSelection.selected.length;
    const numRows = this.defaultServices.length;
    return numSelected === numRows;
  }

  toggleAllPhysicians() {
    if (this.isSelectedPhysicains()) {
      this.orderingPhysicianSelection.clear();
      return;
    }
    this.orderingPhysicianSelection.select(...this.physicianList);
  }

  isSelectedPhysicains() {
    const numSelected = this.orderingPhysicianSelection.selected.length;
    const numRows = this.physicianList.length;
    return numSelected === numRows;
  }

  VaruleExclusionDetails(ruleId: number, labaccountid: any) {
    this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(true))
    this._labadminservice.GetVAruleExclusionDetails(ruleId, this._labadminservice.deploymentKey).subscribe({
      next: (data: VaRulesExclusions[]) => {
        this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(false))
        this.SavedVAExclusionData = data
        this.getFaxAndPrintingData(labaccountid)
      },
      error: (err) => {
        console.error(err)
        this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(false))
      }
    })
  }
  //#region  loader
  loaderKeys = { caseListSection: 'caseListSection', servicesSection: 'servicesSection', physicianSection: 'physicianSection' }
  loaderSections = {
    caseListSection: { loading: false, error: null },
    servicesSection: { loading: false, error: null },
    physicianSection: { loading: false, error: null }
  }
  loader$ = new BehaviorSubject<any>(this.loaderSections)
  getLoaderObj = (loading: boolean = false, error: string | null = null) => ({ loading, error })
  changeLoadingState(sectionKey, value: { loading: boolean, error: string | null }) {
    let result = this.loader$.value
    result[sectionKey] = value
    this.loader$.next(result)
  }


  //#endregion


  getFaxAndPrintingData(LabaccountId: any) {
    if (this.ruleId == 0) {
      this.saveFilteredCaseTypes = this.data.savedObjects
    }
    this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(true))
    forkJoin([
      this.getCasetypeByAccId(LabaccountId),
      this.getServices(),
      this._labadminservice.physicianDataForFaxandPrinting(this.accountId,String(this.loggedInUserId), this._labadminservice.deploymentKey)
    ]).subscribe(([caseCategories, services, accounts]: [any, any, any]) => {
      this.changeLoadingState(this.loaderKeys.caseListSection, this.getLoaderObj(false))
      // Update case categories
      this.caseCategoriesList = caseCategories;

      this.orderingServiceSelection.clear();
      const jsonData = JSON.parse(services.Message);
      this.defaultServices = jsonData.map((item: any, index: number) => ({
        Attribute_Name: item.Attribute_Name,
        Attribute_Type: item.Attribute_Type,
        value: index + 1
      }));
      this.defaultServices =  this.defaultServices.sort((a, b) => {
        return a.Attribute_Name.localeCompare(b.Attribute_Name);
      });

      // Select services excluding those in SavedVAExclusionData

      const serviceExclusionIds = new Set(
        this.SavedVAExclusionData
          .filter(exclusion => exclusion.entityType === 'Service')
          .map(exclusion => +exclusion.entityId)  // Convert entityId to number
      );
      const includedServices = this.defaultServices.filter(service => !serviceExclusionIds.has(service.value));
      this.orderingServiceSelection.select(...includedServices);

      // Update ordering facilities
      this.physicianList = accounts
      this.orderingPhysicianSelection.clear()
      const physicianexclusionIds = new Set(
        this.SavedVAExclusionData
          .filter(exclusion => exclusion.entityType === 'orderingPhysician')
          .map(exclusion => exclusion.entityId)
      );
      this.orderingPhysicianSelection.select(...accounts.filter(attribute => !physicianexclusionIds.has(attribute.UserID)))
    }
    )
  }

  getServices(): Observable<any> {
    let obj = {
      organizationid: -1,
      attributetype: ['Services'],
      casetype: '',
      tablename: 'OrganizationAttributes',
    };
    return this._vitalHttpServices.getOrganizationAttributes(obj, this._labadminservice.deploymentKey)
  }

  //#endregion

}

export interface VaRulesExclusions {
  exclusionId: string,
  ruleId: number,
  entityType: string,
  entityId: string,
}
